import { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "./MainLayout.css";

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      {/* HEADER */}
      <Header onMenuClick={() => setSidebarOpen(true)} />

      {/* MAIN LAYOUT */}
      <div className="layout">
        <div className="desktop-sidebar">
          <Sidebar setSidebarOpen={setSidebarOpen} />
        </div>

        {/* PAGE CONTENT */}
        <div className="main">
          <div className="content">
            <Outlet />
          </div>
        </div>
      </div>

      {/* MOBILE SIDEBAR */}
      <div className={`mobile-sidebar ${sidebarOpen ? "open" : ""}`}>
        <Sidebar setSidebarOpen={setSidebarOpen} />
      </div>

      {/* OVERLAY */}
      {sidebarOpen && (
        <div className="overlay" onClick={() => setSidebarOpen(false)} />
      )}
    </>
  );
}
